<div class="report-item {{data.cells['Color']?.displayText}}" (click)="onClick($event)">
  <div class="tagging-row flex flex-row">
    <div class="tags flex flex-row justify-start items-center">
      <span class="tag">{{data.cells['ReportType']?.displayText}}</span>
      <i *ngIf="data.cells['TooltipIcon'] && data.cells['TooltipIcon'].value"
         matTooltip="{{data.cells['Tooltip'].value}}" class="fa-regular fa-box-archive m-l-10"></i>
    </div>
    <button mat-icon-button
            *ngIf="hasPermission"
            class="icon-dropdown-button archive-button m-l-auto flex flex-row justify-center items-center"
            [matMenuTriggerFor]="menu" (click)="onMenuClick($event)">
      <i class="fa-solid fa-ellipsis"></i>
    </button>
    <mat-menu #menu="matMenu" class="activity-menu">
      <button *ngIf="data.cells['Tag']?.displayText === 'Unarchived' "
              mat-menu-item
              particleAnalytics
              analyticsCategory="action-type-cell-viewer"
              analyticsAction="action-dropdown"
              (click)="onActionClick('Archive')"
      >
        <span>Archive</span>
      </button>
      <button *ngIf="data.cells['Tag']?.displayText === 'Archived'" mat-menu-item

              particleAnalytics
              analyticsCategory="action-type-cell-viewer"
              analyticsAction="action-dropdown"
              (click)="onActionClick('Unarchive')"
      >
        <span>Unarchive</span>
      </button>
    </mat-menu>
  </div>
  <i class="{{data.cells['Icon']?.displayText}}"></i>
  <div class="report-details">
    <div class="report-name">{{data.cells['Name']?.displayText}}</div>
    <div class="report-meta">
      <div class="time">{{data.cells['CreateDate']?.displayText}} </div>
      <div class="author-name">{{data.cells['CreatedBy']?.displayText}}</div>
    </div>


  </div>

</div>


